"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIGNED_URLS_CACHE_TIMEOUT_VALUE = exports.REALTIME_CONNECTION_TIMEOUT_VALUE = void 0;
// Timeout in minutes to burst signed URLs cache
var SIGNED_URLS_CACHE_TIMEOUT_VALUE = exports.SIGNED_URLS_CACHE_TIMEOUT_VALUE = 30;
var REALTIME_CONNECTION_TIMEOUT_VALUE = exports.REALTIME_CONNECTION_TIMEOUT_VALUE = 200;